import { render, staticRenderFns } from "./Options.vue?vue&type=template&id=09911204&"
import script from "./Options.vue?vue&type=script&lang=ts&"
export * from "./Options.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\rafael\\Github\\MultiSelect\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09911204')) {
      api.createRecord('09911204', component.options)
    } else {
      api.reload('09911204', component.options)
    }
    module.hot.accept("./Options.vue?vue&type=template&id=09911204&", function () {
      api.rerender('09911204', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MultiSelect/Options.vue"
export default component.exports